// test1856
(1856 && 0);
